import axios from "axios";

export const getActivePrograms = async () => {
  try {
    const response = await axios.get("/nodeapi/aggregator/active-programs", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const programs = (response.data?.programs || []).filter(
      (program) => program.onlymobile != 1
    );

    return {
      success: true,
      data: programs,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error.message === "Network Error"
          ? "Network Error: Please check your internet connection or try again later."
          : "An error occurred while fetching program list.",
    };
  }
};
